import type { LogoType } from '../../types';

export const infiniteCarousel: LogoType[] = [
  {
    id: '2fe7a0ef-706c-4b63-9619-15153cda1c75',
    file: {
      data: {
        url: 'https://elfsight.com/assets/logo-showcase/test-data/logo1.png',
        width: 299,
        height: 267
      }
    },
    size: 100,
    link: {
      value: '',
      rawValue: '',
      target: '_self',
      type: 'url'
    },
    caption: ''
  },
  {
    id: '8a072d96-5a22-428f-b709-213ae3941b2e',
    file: {
      data: {
        url: 'https://elfsight.com/assets/logo-showcase/test-data/logo2.png',
        width: 300,
        height: 261
      }
    },
    size: 100,
    link: {
      value: '',
      rawValue: '',
      target: '_self',
      type: 'url'
    },
    caption: ''
  },
  {
    id: '1dd7c486-f2db-4ddc-91e5-bb354d06f034',
    file: {
      data: {
        url: 'https://elfsight.com/assets/logo-showcase/test-data/logo3.png',
        width: 297,
        height: 300
      }
    },
    size: 100,
    link: {
      value: '',
      rawValue: '',
      target: '_self',
      type: 'url'
    },
    caption: ''
  },
  {
    id: '19a36af1-5d4c-4a5a-9f14-6f51112be7b7',
    file: {
      data: {
        url: 'https://elfsight.com/assets/logo-showcase/test-data/logo4.png',
        width: 318,
        height: 299
      }
    },
    size: 100,
    link: {
      value: '',
      rawValue: '',
      target: '_self',
      type: 'url'
    },
    caption: ''
  },
  {
    id: 'a0fd0d9d-4f27-413d-a633-116253e7348f',
    file: {
      data: {
        url: 'https://elfsight.com/assets/logo-showcase/test-data/logo5.png',
        width: 228,
        height: 300
      }
    },
    size: 100,
    link: {
      value: '',
      rawValue: '',
      target: '_self',
      type: 'url'
    },
    caption: ''
  },
  {
    id: '48cf2498-31f6-4146-beda-bc840a4d595d',
    file: {
      data: {
        url: 'https://elfsight.com/assets/logo-showcase/test-data/logo6.png',
        width: 300,
        height: 237
      }
    },
    size: 100,
    link: {
      value: '',
      rawValue: '',
      target: '_self',
      type: 'url'
    },
    caption: ''
  },
  {
    id: '1c720219-751f-4213-8e5a-47317843d49f',
    file: {
      data: {
        url: 'https://elfsight.com/assets/logo-showcase/test-data/logo7.png',
        width: 301,
        height: 299
      }
    },
    size: 100,
    link: {
      value: '',
      rawValue: '',
      target: '_self',
      type: 'url'
    },
    caption: ''
  },
  {
    id: 'f063d9a1-156f-4d1d-94ec-921efad5021c',
    file: {
      data: {
        url: 'https://elfsight.com/assets/logo-showcase/test-data/logo8.png',
        width: 300,
        height: 300
      }
    },
    size: 100,
    link: {
      value: '',
      rawValue: '',
      target: '_self',
      type: 'url'
    },
    caption: ''
  },
  {
    id: 'ca344da9-98cd-460e-8bbb-ff2f58c38a33',
    file: {
      data: {
        url: 'https://elfsight.com/assets/logo-showcase/test-data/logo9.png',
        width: 300,
        height: 171
      }
    },
    size: 100,
    link: {
      value: '',
      rawValue: '',
      target: '_self',
      type: 'url'
    },
    caption: ''
  },
  {
    id: '839a74de-a7ca-49ef-b9a7-567770019e6f',
    file: {
      data: {
        url: 'https://elfsight.com/assets/logo-showcase/test-data/logo10.png',
        width: 230,
        height: 298
      }
    },
    size: 100,
    link: {
      value: '',
      rawValue: '',
      target: '_self',
      type: 'url'
    },
    caption: ''
  },
  {
    id: '59e4f397-ef42-41ef-a711-c899ac974772',
    file: {
      data: {
        url: 'https://elfsight.com/assets/logo-showcase/test-data/logo11.png',
        width: 297,
        height: 260
      }
    },
    size: 100,
    link: {
      value: '',
      rawValue: '',
      target: '_self',
      type: 'url'
    },
    caption: ''
  },
  {
    id: 'ea426e56-1068-46b9-9755-6b667e8cad50',
    file: {
      data: {
        url: 'https://elfsight.com/assets/logo-showcase/test-data/logo12.png',
        width: 274,
        height: 75
      }
    },
    size: 100,
    link: {
      value: '',
      rawValue: '',
      target: '_self',
      type: 'url'
    },
    caption: ''
  },
  {
    id: '14c7abff-729d-40d2-8f49-643fee994932',
    file: {
      data: {
        url: 'https://elfsight.com/assets/logo-showcase/test-data/logo13.png',
        width: 300,
        height: 180
      }
    },
    size: 100,
    link: {
      value: '',
      rawValue: '',
      target: '_self',
      type: 'url'
    },
    caption: ''
  },
  {
    id: '0de836e3-600d-478a-a64b-1a9e4faba3a3',
    file: {
      data: {
        url: 'https://elfsight.com/assets/logo-showcase/test-data/logo14.png',
        width: 300,
        height: 140
      }
    },
    size: 100,
    link: {
      value: '',
      rawValue: '',
      target: '_self',
      type: 'url'
    },
    caption: ''
  },
  {
    id: 'aee52604-931b-4bd4-a2ff-b1dbcb684285',
    file: {
      data: {
        url: 'https://elfsight.com/assets/logo-showcase/test-data/logo15.png',
        width: 299,
        height: 105
      }
    },
    size: 100,
    link: {
      value: '',
      rawValue: '',
      target: '_self',
      type: 'url'
    },
    caption: ''
  },
  {
    id: '46cbd880-8ac0-43e8-8d6a-355b488dd57b',
    file: {
      data: {
        url: 'https://elfsight.com/assets/logo-showcase/test-data/logo16.png',
        width: 299,
        height: 156
      }
    },
    size: 100,
    link: {
      value: '',
      rawValue: '',
      target: '_self',
      type: 'url'
    },
    caption: ''
  }
];
